const deepEqual = (a, b) => {
  if (a === b) return true

  if (
    typeof a !== "object" ||
    typeof b !== "object" ||
    a === null ||
    b === null
  ) return false

  const keysA = Object.keys(a)
  const keysB = Object.keys(b)

  if (keysA.length !== keysB.length) return false

  for (const key of keysA) {
    if (!keysB.includes(key)) return false

    const valA = a[key]
    const valB = b[key]

    const bothObjects =
      typeof valA === "object" &&
      typeof valB === "object" &&
      valA !== null &&
      valB !== null

    if (
      bothObjects
        ? !deepEqual(valA, valB)
        : valA !== valB
    ) {
      return false
    }
  }

  return true
}

export default deepEqual